
<p-dialog [(visible)]="visible" [modal]="true" (onHide)="onHideDataDialog()">

  <ami-table-actions
  [settings]="tableDetailSettings"
  [data]="detailsResponseFlattenned"
  >
  </ami-table-actions>

</p-dialog>